<template>
  <div class="landing font_Montserrat">
    <b-container>
      <b-row>
        <b-col sm="12" md="6" class="text-center">
          <h2 class="v2_font_size_22 v2_font_weight_semibold v2_color_black">
            Are you a medical practitioner?
          </h2>
          <div class="v2_bg_white v2_box_teal w-100 h-100 p-5 mt-3">
            <p class="">
              Find more information at &nbsp;<a
                href="https://phairify.com/how-it-works/for-physicians"
                class="btn-v2_link"
                >Phairify.com</a
              >
            </p>
            <p class="">
              Already registered?
              <router-link to="/login" class="btn-v2_link">Sign In</router-link>
            </p>
          </div>
        </b-col>
        <b-col sm="12" md="6" class="text-center mt-5 mt-md-0 pt-2 pt-md-0">
          <h2 class="v2_font_size_22 v2_font_weight_semibold v2_color_black">
            Are you a recruiter?
          </h2>
          <div
            class="v2_bg_white v2_box_teal w-100 h-100 p-5 mt-3 d-flex flex-column justify-content-between"
          >
            <div>
              <router-link to="/recruiter/sign-up" class="btn btn-v2_primary">
                Register
              </router-link>
              <p class="d-flex align-items-center justify-content-center">
                Already registered?
                <router-link to="/login" class="btn-v2_link">
                  Sign In
                </router-link>
              </p>
            </div>
            <p>
              Want to browse ICOs? Go to our
              <router-link to="/recruiter/ico" class="btn-v2_link">
                ICO browser
              </router-link>
            </p>
            <p>
              Want more info? Go to the
              <router-link to="/recruiter/faq" class="btn-v2_link">
                FAQ
              </router-link>
            </p>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'Landing',
};
</script>

<style scoped />
